/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Pump_Turn_OffInputs */

const vi_irrigation_pump_turn_off = /** @type {(inputs: Irrigation_Pump_Turn_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tắt`)
};

/**

* @param {Irrigation_Pump_Turn_OffInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_pump_turn_off = /** @type {((inputs?: Irrigation_Pump_Turn_OffInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Pump_Turn_OffInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_pump_turn_off(inputs)
});